/**
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   index.js
 */

import type { RouteComponentProps } from '@zcode/router-utils'
import type { Location } from 'history'
import qs from 'querystringify'
import { compose } from 'redux'

export const selectRouteLocation = (routeProps: RouteComponentProps): Location | undefined =>
  routeProps?.location

export const selectPathname = compose(
  (location) => (location ? location.pathname : null),
  selectRouteLocation
)

export const selectSearch = compose(
  (location) => (location ? location.search : null),
  selectRouteLocation
)

export const selectQuery = compose((search) => (search ? qs.parse(search) : null), selectSearch)

export const selectUtmMedium = compose((query) => (query ? query.utm_medium : null), selectQuery)
